import { apiClient } from '@/services/'

export const namespaced = true

export const state = {
  loadingPage: false,
  loadingTable: false,
  edited: false,
  etarList: [],
  currentEtar: {},
  tableData: [],
  updatedTableData: [],
}

export const mutations = {
  SET_LOADING_PAGE(state, status) {
    state.loadingPage = status
  },
  SET_LOADING_TABLE(state, status) {
    state.loadingTable = status
  },
  SET_ETARS(state, status) {
    state.etarList = status
  },
  SET_CURRENT_ETAR(state, status) {
    state.currentEtar = status
  },
  SET_ETAR_TABLE_DATA(state, status) {
    state.tableData = status
  },
  SET_ETAR_EDITED(state, status) {
    state.edited = status
  },
  SET_ETAR_UPDATED_TABLE(state, status) {
    state.updatedTableData = status
  },
}

export const actions = {
  getEtars({ commit, rootState, dispatch }) {
    commit('SET_LOADING_PAGE', true)
    return apiClient
      .get('/GetStudTarList', {
        params: {
          sAdName: rootState.adName,
        },
      })
      .then((response) => {
        commit('SET_ETARS', response.data)
        commit('SET_LOADING_PAGE', false)
        dispatch('getEtarDetails', response.data[0])
        // Has ETARs - MN
        if (response.data.length > 0) {
          rootState.userInfo.userRole.push(4)
        }
      })
  },
  getEtarDetails({ commit }, currentEtar) {
    commit('SET_CURRENT_ETAR', currentEtar)
    commit('SET_LOADING_TABLE', true)
    return apiClient
      .get('/GetStudTarMaintDetailsForHtmlTable', {
        params: {
          TarId: currentEtar.tarId,
          EnrTarId: currentEtar.enrTarId,
        },
      })
      .then((response) => {
        // Format data for use - MN
        const tableData = response.data.studTarDetailList.map((x) => {
          return {
            ...x,
            // Only display completed ratings. - MN
            ratingCd: x.staffCompDt ? x.ratingCd : 0,
            // FIXME: Data Issue - Replace unknown characters in TAR descriptions. - MN
            tarDetailDescNoHtmlTags: x.tarDetailDescNoHtmlTags
              ? x.tarDetailDescNoHtmlTags.replace(
                  /[^\w\s .,/#!$%^&*;:{}=\-_`~()'"[\]]/gi,
                  '-'
                )
              : '',
            // Maintain original sign off dates, add space to table for tracking edits - MN
            editedSignoff: x.studentSignoff,
            editedSignoffDt: x.studentSignoffDt,
            editedComment: false,
          }
        })
        // Save outline level for UI formatting - MN
        // Get top level parent ids
        let ParentContainer = tableData
          .filter((s) => s.parentId == 0)
          .map((m) => {
            return m.tarDetailId
          })
        // Find next level and add token to tarChildLevel
        for (let i = 1; i < 7; i++) {
          const ChildContainer = [],
            levelAssign = { tarChildLevel: i }
          tableData.forEach((element, index) => {
            if (ParentContainer.includes(element.parentId)) {
              ChildContainer.push(element.tarDetailId)
              Object.assign(tableData[index], levelAssign)
            }
          })
          ParentContainer = ChildContainer
        }
        commit('SET_ETAR_TABLE_DATA', tableData)
        commit('SET_LOADING_TABLE', false)
        commit('SET_ETAR_EDITED', false)
      })
  },
  saveTable({ state, commit, dispatch }) {
    commit('SET_LOADING_TABLE', true)
    apiClient.post('/UpdateStudPortalTar', state.updatedTableData).then(() => {
      dispatch('getEtarDetails', state.currentEtar)
      commit('SET_ETAR_UPDATED_TABLE', [])
    })
  },
}

export const getters = {}
